import ApiError from "./ApiError";

export default class LoginRequiredError extends ApiError {

}
